import { useEffect, useState } from "react";
import { Button, CircularProgress, Grid, Typography } from "@mui/material";
import theme from "../../theme";
import BasicTextField from "../forms/formElements/BasicTextField";
import useButtonStyles from "../../styles/useButtonStyles";
import { useAppSelector } from "../../redux/hooks";
import BasicModal from "../ui/BasicModal";
import { handleSubmit } from "../../services/ApiServices/UpdateEmail";
import { errorMessageConstants } from "../../constants/AppConstants";

interface UpdateEmailProps {
  handleCloseUpdateEmail: () => void;
  handlePageNavigation: () => void;
}

function UpdateEmail({ handleCloseUpdateEmail,handlePageNavigation }: UpdateEmailProps) {
  const buttonStyles = useButtonStyles();
  const [message, setMessage] = useState("");
  const [oldEmail, setOldEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [newEmail, setNewEmail] = useState({ email: "" });
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [uploadError, setUploadError] = useState<boolean>(false);
  const [confirmNewEmail, setConfirmNewEmail] = useState({ email: "" });
  const [visitedConfirmEmail, setVisitedConfirmEmail] = useState(false);

  const memberDetails = useAppSelector(
    (state: any) => state.persistReducers.getMemberList?.membersList
  );

  const handleFormSubmit = async (e: { preventDefault: () => void }) => {
    e.preventDefault();
    handleSubmit(
      newEmail.email,
      memberDetails,
      setLoading,
      setShowModal,
      setUploadError,
      setMessage
    );
  };

  const notSameEmailError = () => {
    return visitedConfirmEmail && newEmail?.email !== confirmNewEmail?.email
      ? errorMessageConstants.notSameEmailError
      : "";
  };
  const sameEmailError = () => {
    return memberDetails.email === newEmail.email
      ? errorMessageConstants.sameEmailError
      : "";
  };

  useEffect(() => {
    if (memberDetails) {
      setOldEmail(memberDetails.email);
    }
  }, [memberDetails]);

  useEffect(() => {
    if (confirmNewEmail.email !== "") {
      setVisitedConfirmEmail(true);
    }
    setDisableSubmit(
      !confirmNewEmail ||
        newEmail.email !== confirmNewEmail.email ||
        memberDetails.email === newEmail.email
    );
  }, [confirmNewEmail, newEmail.email]);

  return (
    <Grid
      container
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      padding={4}
    >
      <Typography
        variant="h6"
        sx={{
          fontFamily: theme.font?.fontFamily.primary,
          marginBottom: 2,
        }}
      >
        Update Email
      </Typography>
      <form
        onSubmit={handleFormSubmit}
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: "4vh",
        }}
      >
        <BasicTextField
          placeholder=""
          defaultValue={memberDetails.email}
          type="email"
          readonly
          stateKey={"email"}
          setState={setOldEmail}
        />
        <BasicTextField
          placeholder="New Email"
          value={newEmail.email}
          type="email"
          required
          disableSubmit={setDisableSubmit}
          stateKey={"email"}
          setState={setNewEmail}
          errorMessage={sameEmailError()}
        />

        <BasicTextField
          placeholder="Confirm New Email"
          value={confirmNewEmail.email}
          type="email"
          required
          setState={setConfirmNewEmail}
          errorMessage={notSameEmailError()}
          stateKey={"email"}
        />

        <Grid
          display={"flex"}
          marginTop={"20px"}
          justifyContent={"space-between"}
        >
          <Button
            type="button"
            variant="contained"
            color="primary"
            sx={{ ...buttonStyles.containedSecondary, width: "45%" }}
            onClick={handleCloseUpdateEmail}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            sx={{ ...buttonStyles.containedSecondary, width: "45%" }}
            disabled={loading || disableSubmit}
          >
            {loading ? <CircularProgress size={20} /> : "Submit"}
          </Button>
        </Grid>
      </form>
      {showModal && (
        <BasicModal
          title={message}
          success={!uploadError}
          setState={setShowModal}
          onCloseModule={handlePageNavigation}
        />
      )}
    </Grid>
  );
}

export default UpdateEmail;
